import {createStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core/styles';
import * as colors from 'assets/theme/colors';

export default createStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    top: {
        color: `${colors.neutrals.A10} !important`,
    },
    bottom: {
        color: `${colors.primary.A00} !important`,
        position: 'absolute',
        left: 0,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 300,
        color: '#fff',
    },
    label: {
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
        fontSize: theme.typography.pxToRem(14),
    },
}));
